import {ElectionIncidence} from "../lib/types";
import Alert from "../../../assets/img/alarm.png"

type Props = {
    newIncidence: ElectionIncidence []
}


export const NewIncidents = ({newIncidence}:Props) => {
    return (
        <>
            <p className="text-center text-2xl font-bold text-gray-800 mt-10">New Alerts</p>
            {newIncidence.map((incidence:ElectionIncidence) =>
                <div className="flex flex-wrap justify-between items-center py-4 border borderde-1 m-2 rounded-md border-black">
                    <div className="px-2">
                        <img src={Alert} alt={"alert"} className="w-[20px]"/>
                    </div>
                    <p className="text-left">{incidence.created_at}</p>
                <p  className="text-left">{incidence.constituency}</p>
                <p  className="px-2">{incidence.incidence_type}</p>
            </div>)}
        </>
    );
};
